import { z } from "zod";

// Location schemas
export const createLocationSchema = z.object({
  name: z
    .string()
    .min(1, "El nombre de la ubicación es requerido")
    .max(100, "El nombre de la ubicación debe tener menos de 100 caracteres"),
  description: z
    .string()
    .max(500, "La descripción debe tener menos de 500 caracteres")
    .optional(),
});

export const updateLocationSchema = z.object({
  name: z
    .string()
    .min(1, "El nombre de la ubicación es requerido")
    .max(100, "El nombre de la ubicación debe tener menos de 100 caracteres")
    .optional(),
  description: z
    .string()
    .max(500, "La descripción debe tener menos de 500 caracteres")
    .optional(),
});

// Zone schemas
export const createZoneSchema = z.object({
  name: z
    .string()
    .min(1, "El nombre de la zona es requerido")
    .max(100, "El nombre de la zona debe tener menos de 100 caracteres"),
  description: z
    .string()
    .max(500, "La descripción debe tener menos de 500 caracteres")
    .optional(),
  locationId: z.string().min(1, "El ID de la ubicación es requerido"),
});

export const updateZoneSchema = z.object({
  name: z
    .string()
    .min(1, "El nombre de la zona es requerido")
    .max(100, "El nombre de la zona debe tener menos de 100 caracteres")
    .optional(),
  description: z
    .string()
    .max(500, "La descripción debe tener menos de 500 caracteres")
    .optional(),
});
// Job Position schemas
export const createJobPositionSchema = z.object({
  name: z
    .string()
    .min(1, "El nombre del puesto de trabajo es requerido")
    .max(
      100,
      "El nombre del puesto de trabajo debe tener menos de 100 caracteres",
    ),
  description: z
    .string()
    .max(500, "La descripción debe tener menos de 500 caracteres")
    .optional(),
});

export const updateJobPositionSchema = z.object({
  name: z
    .string()
    .min(1, "El nombre del puesto de trabajo es requerido")
    .max(
      100,
      "El nombre del puesto de trabajo debe tener menos de 100 caracteres",
    )
    .optional(),
  description: z
    .string()
    .max(500, "La descripción debe tener menos de 500 caracteres")
    .optional(),
});

// Export types
export type CreateLocationSchema = z.infer<typeof createLocationSchema>;
export type UpdateLocationSchema = z.infer<typeof updateLocationSchema>;
export type CreateZoneSchema = z.infer<typeof createZoneSchema>;
export type UpdateZoneSchema = z.infer<typeof updateZoneSchema>;
export type CreateJobPositionSchema = z.infer<typeof createJobPositionSchema>;
export type UpdateJobPositionSchema = z.infer<typeof updateJobPositionSchema>;
